import { exhaustiveFail } from '@cbridge-utils/error';
import { ApiUserRole, IApiUser, IApiNewUser } from '@cbridge-packages/api';
import { IUser, UserRole, IUserForm } from './user.interface';

export namespace UserTranslator {
  export function fromApi(user: IApiUser): IUser {
    return {
      userId: user.userId,
      username: user.username,
      roles: user.roles?.map((role) => UserTranslator.fromApiUserRole(role)),
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    };
  }

  export function toApi(user: IUserForm): IApiNewUser {
    return {
      password: user.password,
      username: user.username,
      roles: user.roles?.map((role) => UserTranslator.toApiUserRole(role)),
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    };
  }

  export function fromApiUserRole(role: ApiUserRole): UserRole {
    switch (role) {
      case ApiUserRole.Manager:
        return UserRole.Manager;
      case ApiUserRole.Viewer:
        return UserRole.Viewer;
      default:
        return exhaustiveFail(role);
    }
  }

  export function toApiUserRole(role: UserRole): ApiUserRole {
    switch (role) {
      case UserRole.Manager:
        return ApiUserRole.Manager;
      case UserRole.Viewer:
        return ApiUserRole.Viewer;
      default:
        return exhaustiveFail(role);
    }
  }
}
